import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { sk } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css'; 

registerLocale('sk', sk);

const DarkDatePicker = ({ selected, onChange, showTimeSelect, dateFormat }) => (
  <DatePicker
    selected={selected}
    onChange={onChange}
    showTimeSelect={showTimeSelect}
    dateFormat={dateFormat}
    locale="sk"
    timeFormat="HH:mm"
    timeIntervals={15}
    timeCaption="Čas"
    calendarStartDay={1} 
    placeholderText="Vyberte dátum a čas"
    popperClassName="dark-datepicker-popper"
  />
);

export default DarkDatePicker;
